import * as React from "react";

import {LearningTimeInfoApi} from "./learning-time-info-api.ts";

export const LearningTimeInfoApiContext =
    React.createContext<LearningTimeInfoApi>(
        new LearningTimeInfoApi({}), // we don't have any context at the root
    );
